import React, { useState, useContext, useReducer } from "react";

import GlobalContext                      from "../../isp._comun/contexto/GlobalContext";
import * as TipoDeError                   from "../../isp._comun/servicios/Errores";
import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";

import ServicioDeQueryDeItems             from "../../isp.servicios.items/ServicioDeQueryDeItems";

import QueryItemReducer from "../reductores/QueryItemReducer";
import CargaDeItemsBuscados from "../reductores/acciones/dispatch/CargaDeItemsBuscados";
import FinalizarComando from "../reductores/acciones/dispatch/FinalizarComando";


import DialogQueryItems from "./layouts/DialogQueryItems";
import ComandoAPI from "./ComandoAPI";

const DialogoInteractivoDeQueryDeItems = ({ ventana }) => {
    const { notificar } = useContext(GlobalContext);

    const [estadoQ, dispatchQ] = useReducer(QueryItemReducer, {
        data: [],
        params: {},
        flag: {
            procesandoComando: false,
            procesandoBusquedaUnSoloCliente: false,
        },
        // idClienteSelec: null,
    });

    const buscarItemsCommand = new ComandoAPI();
    buscarItemsCommand.ejecutar = useHandlerDeComandoConSesionActiva(async (paramsQuery) => {
    // const buscarItems = useHandlerDeComandoConSesionActiva(async (paramsQuery) => {
        /* const clienteAFactPorActualizar = {
            id: estadoDCF.domain.screen.idCliente,
            data: estadoDCF.domain.update,
        }; */

        try {
            buscarItemsCommand.servicio = new ServicioDeQueryDeItems();
            const respuestaQuery = await buscarItemsCommand.servicio.ejecutar(paramsQuery);
            /* const respuestaQuery = await new ServicioDeQueryDeClientesAFacturar().ejecutar(
                paramsQuery
            ); */
            // dispatchQ(new CargaDeItemsBuscados(respuestaQuery.clientes));
            dispatchQ(new CargaDeItemsBuscados(respuestaQuery.items));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            throw error;
        }
    });

    

    return (
        <DialogQueryItems
            ventana={ventana}
            dispatchQ={dispatchQ}
            estadoQ={estadoQ}
            buscarItems={buscarItemsCommand}
            // buscarItems={buscarItems}

        />
    );
};

export default DialogoInteractivoDeQueryDeItems;
